// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nzzl","type":"styles_type__2eLqp","choices":"styles_choices__27lUg"};